<div [class.block-loader]="loader$ | async">
	<loader-spinner [model]="loader"></loader-spinner>

<div class="modal-header">
	<h2 class="modal-title">
		<span> Désarchiver {{ count }} affaire(s) </span>
	</h2>
	<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
</div>

<div class="modal-body">
	<form [formGroup]="form">
		<div class="row">
			<h2 style="text-transform: none; font-size: larger">
				{{ 'UnarchiveModal.Question' | translate }}
			</h2>

			<div style="display: flex; justify-content: space-between">
				<div *ngFor="let filtre of unarchiveFilter">
					<div class="custom-radio-group">
						<label class="custom-radio" for="field-affaire-unarch-filtre-{{ buildInputId(filtre.value) }}">
							<input
								id="field-affaire-unarch-filtre-{{ buildInputId(filtre.value) }}"
								type="radio"
								[value]="filtre.key"
								formControlName="selectedOption"
							/>
							<span class="label-text">{{ filtre.value }}</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="onClose()">
		<i class="far fa-times"></i>
		{{ 'Actions.Cancel' | translate }}
	</button>
	<button type="button" class="btn btn-primary" (click)="onUnarchive()">
		<i class="far fa-save"></i>
		{{ 'Actions.Confirm' | translate }}
	</button>
</div>

</div>
